import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { UserInformationPopover } from 'src/app/_provider/userselect.service';

@Component({
  selector: 'app-user-information',
  templateUrl: './user-information.component.html',
  styleUrls: ['./user-information.component.scss'],
})
export class UserInformationComponent implements OnInit {

  @Input() employeeInformationPosition: UserInformationPopover

  @ViewChild("userInformation", {static: false}) public element: ElementRef

  constructor(
    public darkmode: DarkmodeService
  ) { }

  ngOnInit() {}

}
